import { useDisplayOptionContext } from "./useDisplayOptionContext";
import { useGetFacilitiesV2Query } from "@/features/api/apiSlice";

export const useFacilities = () => {
    const { facilityIds } = useDisplayOptionContext();
    const { data, isLoading, error } = useGetFacilitiesV2Query({
        ids: facilityIds.join(","),
        withSettings: true,
    });

    return {
        facilities: data?.data || [],
        isLoading,
        error,
    };
};